import Vue from 'vue'
import Router from 'vue-router'
import app from '@/components/download'
import testApp from '@/components/testDownload'
import correlation from '@/components/correlation'
import explain from '@/components/explain'
import introduce from '@/components/introduce'
import invite from '@/components/invite'
import productInfo from '@/components/productInfo'
import senasicInfo from '@/components/senasicInfo'
import productConfig from '@/components/productConfig'
import trailerInfoCard from '@/components/trailerInfoCard'

Vue.use(Router)
const router = new Router({
  routes: [
    {
      path: '/T*',
      name: 'app下载',
      component: testApp
    },
    {
      path: '/correlation',
      name: '关于TORO胎压',
      component: correlation
    },
    {
      path: '/explain',
      name: 'TORO',
      component: explain,
      meta: {
        title: "车辆定位及资产管理",
     }
    },
    {
      path: '/introduce',
      name: 'TORO',
      component: introduce,
      meta: {
        title: "轮端感知及服务解决方案",
     }
    },
    {
      path: '/productConfig',
      name: 'TORO',
      component: productConfig,
      meta: {
        title: "产品配置",
     }
    },
    {
      path: '/invite*',
      name: '邀请',
      component: invite
    },
    {
      path: '/A*',
      name: '关注公众号',
      component: app
    },
    {
      path: '/R*',
      name: 'app下载',
      component: app
    },
    {
      path: '/show*',
      name: 'app下载',
      component: app
    },
    {
      path: '/S*',
      name: '传感器信息',
      component: productInfo,
      meta: {
        // title: "PREMIERNONOSENSOR",
        title: "TPMS",
     }
    },
    {
      path: '/Z*',
      name: '轴温传感器信息',
      component: productInfo,
      meta: {
        title: "TPMS",
     }
    },
    {
      path: '/Q*',
      name: '传感器信息',
      component: senasicInfo,
      meta: {
        title: "SENASIC SENSOR",
     }
    },
    {
      path: '/G*',
      name: '挂车信息牌',
      component: trailerInfoCard,
      meta: {
        title: "轮端感知信息牌",
     }
    },
    {
      path: '/',
      name: 'TORO车辆轮端预警',
      component: app
    }
  ]
})
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
      document.title = to.meta.title;
  }
  next();
})
// 路由器
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js